interface StyleConfig {
  paddingTop: string;
  paddingLeft: string;
  paddingRight: string;
  paddingBottom: string;
  marginLeft: string | number;
  width: string;
  height?: string;
}
//Do not remove the comments
export const MAIN_CONTENT_SPACING = {
  // Top Navigation Mode
  TOP_NAV: {
    paddingTop: '64px', // Top bar height + spacing
    paddingLeft: '2rem', // Left padding
    paddingRight: '2rem', // Right padding
    paddingBottom: '1.5rem', // Bottom padding
    marginLeft: '0px', // No margin from sidebar
    width: '100%' // Full width
  },

  // Sidebar Mode - Expanded
  SIDEBAR_EXPANDED: {
    paddingTop: '64px', // Top bar height + spacing
    paddingLeft: '1rem', // Reduced left padding
    paddingRight: '1rem', // Reduced right padding
    paddingBottom: '1.5rem', // Bottom padding
    marginLeft: '250px', // Sidebar width
    width: 'calc(100% - 250px)' // Remaining width
  },

  // Sidebar Mode - Collapsed
  SIDEBAR_COLLAPSED: {
    paddingTop: '64px', // Top bar height + spacing
    paddingLeft: '1rem', // Reduced left padding
    paddingRight: '1rem', // Reduced right padding
    paddingBottom: '1.5rem', // Bottom padding
    marginLeft: '70px', // Collapsed sidebar width
    width: 'calc(100% - 70px)' // Remaining width
  },

  // Mobile Mode
  MOBILE: {
    paddingTop: '64px', // Mobile top bar + spacing
    paddingLeft: '1rem', // Mobile left padding
    paddingRight: '1rem', // Mobile right padding
    paddingBottom: '1.5rem', // Bottom padding
    marginLeft: '0px', // No margin on mobile
    width: '100%' // Full width on mobile
  },

  // Hidden Navigation
  HIDDEN_NAV: {
    paddingTop: '0px', // No padding
    paddingLeft: '0px', // No padding
    paddingRight: '0px', // No padding
    paddingBottom: '0px', // No padding
    marginLeft: '0px', // No margin
    width: '100%', // Full width
    height: '100vh' // Full height
  }
} as const;

export const getMainContentStyles = (hideNavigation: boolean, isMobile: boolean, isSideNav: boolean, isCollapsed: boolean): StyleConfig => {
  if (hideNavigation) return MAIN_CONTENT_SPACING.HIDDEN_NAV;
  if (isMobile) return MAIN_CONTENT_SPACING.MOBILE;
  if (!isSideNav) return MAIN_CONTENT_SPACING.TOP_NAV;
  if (isSideNav && isCollapsed) return MAIN_CONTENT_SPACING.SIDEBAR_COLLAPSED;
  if (isSideNav && !isCollapsed) return MAIN_CONTENT_SPACING.SIDEBAR_EXPANDED;
  return MAIN_CONTENT_SPACING.TOP_NAV;
};
